import { CreatorChallenge } from '../../../../types/challenges';
import {
  formatChallengeCompletedDate,
  getChallengeTitle,
  isChallengeRewardClaimable,
} from '../../../../utils/challenge-utils';
import ButtonComponent from '../../../common/button-component/button-component';
import ChevronIcon from '../../../../assets/icons/challenge-chevron.svg';
import ChallengeRewardValue from './ChallengeRewardValue';
import styles from './allChallenges.module.css';

type CompletedChallengeCardProps = {
  challenge: CreatorChallenge;
  defaultCurrency: string;
  onClaimReward: (challenge: CreatorChallenge) => void;
  onOpenDetails: (challenge: CreatorChallenge) => void;
};

export default function CompletedChallengeCard({
  challenge,
  defaultCurrency,
  onClaimReward,
  onOpenDetails,
}: CompletedChallengeCardProps) {
  const isClaimable = isChallengeRewardClaimable(challenge);

  return (
    <div
      className={styles.rewardCard}
      role="button"
      tabIndex={0}
      onClick={() => onOpenDetails(challenge)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onOpenDetails(challenge);
        }
      }}
    >
      <div className={styles.cardTitleRow}>
        <p className={styles.cardTitle}>{getChallengeTitle(challenge, defaultCurrency)}</p>
        <img src={ChevronIcon} alt="" className={styles.cardChevron} width={24} height={24} />
      </div>
      <p className={styles.cardMeta}>
        <ChallengeRewardValue challenge={challenge} defaultCurrency={defaultCurrency} showType />
      </p>
      <p className={styles.cardDate}>Completed on {formatChallengeCompletedDate(challenge.completedAt)}</p>
      {isClaimable && (
        <ButtonComponent
          variant="primaryOutline"
          className={styles.cardClaimButton}
          textStyle={{ fontSize: '14px', fontWeight: 500 }}
          onClick={(event) => {
            event.stopPropagation();
            onClaimReward(challenge);
          }}
        >
          Claim reward
        </ButtonComponent>
      )}
    </div>
  );
}
